<template>
	<div :class="['element', {visible: isVisible}, {slide: slide, slideRight: slideRight}]" v-observe-visibility="{callback: cardVisible, once: true, throttle: delay}">
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'CommonVisibilityAnimation',
  props: [ 'delay', 'slide', 'slideRight' ],
  data: () => {
    return {
      isVisible: false, // whether or not the card is currently visible on the screen
    }
  },
  methods: {
    /**
     * Callback for when visiblity changes
     * @param  Boolean  isVisible   Whether or not the card is visible
     * @return void
     */
    cardVisible (isVisible) {
      this.isVisible = isVisible
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/_variables';

.element {
//   background-color: #F4F7F9;
  // border: 2px solid #EFEFEF;
//   margin: 0 0 40px;
//   position: relative;
  opacity: 0;
  
// top: 100px;
  transition: opacity 1000ms, transform 600ms;
  &.slide {
    transform: translateY(50px);
  }
  &.slideRight{
    transform: translateX(100px);
  }
  &.visible {
    opacity: 1;
    top: 0;
    transform: translateY(0px);
  }
}
</style>
